"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Avatar_1 = __importDefault(require("../Avatar"));
var prism_icons_1 = require("@octanner/prism-icons");
var styles_1 = require("../Search/styles");
var getAriaLabel = function (disabled, isSelected, title) {
    switch (true) {
        case disabled:
            return "".concat(title, " read only");
        case isSelected:
            return "".concat(title, " selected");
        default:
            return title;
    }
};
var SearchOptionCard = react_1.default.forwardRef(function (_a, ref) {
    var avatarUrl = _a.avatarUrl, disabled = _a.disabled, disabledText = _a.disabledText, selected = _a.selected, showAvatar = _a.showAvatar, subTitle = _a.subTitle, title = _a.title, type = _a.type, props = __rest(_a, ["avatarUrl", "disabled", "disabledText", "selected", "showAvatar", "subTitle", "title", "type"]);
    return (react_1.default.createElement(styles_1.StyledBox, __assign({ component: "li", ref: ref, disabled: disabled, "aria-label": getAriaLabel(disabled, Boolean(props['aria-selected']), title) }, props),
        react_1.default.createElement(styles_1.AvatarTitleWrap, { selected: selected },
            showAvatar && (react_1.default.createElement(styles_1.AvatarContainer, { disabled: disabled },
                react_1.default.createElement(Avatar_1.default, { src: avatarUrl, alt: title, size: "sm" }))),
            react_1.default.createElement(styles_1.TitleContainer, null,
                react_1.default.createElement(styles_1.Title, { disabled: disabled },
                    " ",
                    title),
                subTitle && (react_1.default.createElement(styles_1.Title, { sub: true, disabled: disabled }, subTitle))),
            react_1.default.createElement(styles_1.Title, { light: true },
                " ",
                (disabled && disabledText) || type)),
        react_1.default.createElement(styles_1.CheckWrap, null, selected && react_1.default.createElement(prism_icons_1.Check, null))));
});
exports.default = SearchOptionCard;
//# sourceMappingURL=SearchOptionCard.js.map